import { render, staticRenderFns } from "./bnvfile.vue?vue&type=template&id=4f38350a&"
import script from "./bnvfile.vue?vue&type=script&lang=js&"
export * from "./bnvfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports